export class User {
  password = "";
  confirmPassword = "";
  fullName = "";
  email = "";
  isTermsAndConditionsAccepted = false;
}

export class Contact {
  email = "";
  name = "";
  phoneNo = "";
  isPrimary = false;
  sendSms = false;
  sendEmail = false;
}

export class Address {
  addressLine1 = "";
  addressLine2 = "";
  city = "";
  postCode = "";
}
export class Reception {
  virtualNumberPrefix = "";
  virtualNumberRange = "";
  virtualNumberNumber = "";
  numberPlan = "";
  description = "";
  openingHours = "";
  phoneNo = "";
  website = "";
  email = "";
  contacts = [];
  shouldCollectCompanyName: boolean = false;
  greeting: "";
}

export class Client {
  name = "";
  isActive = true;
  isDeleted = false;
  phoneNumber = "";
  emailAddress = "";
  description = "";
  website = "";
  openingHours: "";
  companyAddressLine1: "";
  companyAddressLine2: "";
  companyAddressLine3: "";
  companyCity: "";
  companyCounty: "";
  companyCountry: "";
  companyPostCode: "";
  billingAddressLine1: "";
  billingAddressLine2: "";
  billingAddressLine3: "";
  billingCity: "";
  billingCounty: "";
  billingCountry: "";
  billingPostCode: "";
  receptions = [];
  isReseller = false;
  isSuspended = false;
}

export class Payment {
  clientId = 0;
  paymentType = 0;
  amountToPay = 0;
  topUpAmount = 0;
  cardId = 0;
  cardHolderName = "";
  createAutoTopUp = false;
  saveCardDetails = false;
  cardDescription = "";
}

export class signUpForm {
  franchiseCode = "";
  resellerId = 0;
  signUpCode: "";
  user = new User();
  client = new Client();
  amount = 0;
}

export class signUpResult {
  status = "";
  errorMessage = "";
  isRectifiableError = false;
  clientId = 0;
  franchiseeId = 0;
  isManager = false;
  amountToPay = 0;
}
